import { render, staticRenderFns } from "./DocsDetailClass.vue?vue&type=template&id=65370f94&"
import script from "./DocsDetailClass.vue?vue&type=script&lang=js&"
export * from "./DocsDetailClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports